/**
 * Navigation Store
 *
 * @author jaehyub.lee@emcast.com
*/
// states
const state = {
    isOpenCategory: false,
}

// getters
const getters = {
}

// mutations
const mutations = {
    SET_IS_OPEN_CATEGORY(state, value) {
        state.isOpenCategory = value;
    },
}

// actions
const actions = {
    SET_IS_OPEN_CATEGORY({ commit } , value) {
        commit('SET_IS_OPEN_CATEGORY', value)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}